import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IdGenerator } from '../helpers/IdGenerator';

@Component({
  selector: 'app-custom-checkbox',
  templateUrl: './custom-checkbox.component.html',
  styleUrls: ['./custom-checkbox.component.scss']
})
export class CustomCheckboxComponent implements OnInit {

  uniqueID: string = IdGenerator.generate(3);
  @Input() value: boolean = true;
  @Input() label: string = "";
  @Input() enabled: boolean = true;
  @Output() onChange = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  toggle() {
    if(this.enabled) {
      this.value = !this.value;
      this.onChange.emit(this.value);
    }
  }

  getImageSrc(): string {
    if(this.value && this.enabled){
      return "./assets/images/checkbox_checked.png";
    }
    else if(this.value && !this.enabled) {
      return "./assets/images/checkbox_checked_gray.png";
    }
    else if(!this.value && this.enabled) {
      return "./assets/images/checkbox_unchecked.png";
    }
    else if(!this.value && !this.enabled) {
      return "./assets/images/checkbox_unchecked_gray.png";
    }
  }

}
